import { generateAnnualNoticeSummaryPDF } from "./PDFGenerator";

export const generateAnnualNoticeSummaryDocument = async (
  clientData,
  buildingData,
  units = []
) => {
  try {
    const clientName = clientData?.company_name || clientData?.name || "Selected Client";
    const buildingAddress =
      buildingData?.address ||
      buildingData?.building_address ||
      buildingData?.name ||
      "";

    const unitRows = (Array.isArray(units) ? units : buildingData?.units || [])

    const doc = await generateAnnualNoticeSummaryPDF(unitRows, clientName, buildingData);
    doc.save(`${clientName}_Annual_Notice_Summary.pdf`);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error generating Annual Notice Summary document:", error);
  }
};


